export default {
  modalTrigger: {
    id: 'product_highlighted_picker_modal_trigger',
    defaultMessage: 'Learn more',
  },
}
